import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronUpOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="m3.726 20.716 12.29-12.29 12.29 12.28a1 1 0 0 0 1.41-1.41l-13-13a1 1 0 0 0-1.42 0l-13 13a1 1 0 0 0 0 1.42 1 1 0 0 0 1.43 0"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronUpOutlineSVG);
ForwardRef.displayName = "IconChevronUpOutline";
export { ForwardRef as IconChevronUpOutline };
